export const PRODUCT_TYPE_ACTUAL_PRODUCT = 'ACTUAL_PRODUCT';
export const PRODUCT_TYPE_E_COUPON = 'E_COUPON';

export const TAB_CATEGORY = 'category';
export const TAB_BRAND = 'brand';
export type E_COUPON_SEGMENT_TYPE = typeof TAB_CATEGORY | typeof TAB_BRAND;
export const E_COUPON_SEGMENT_TAB_LIST: {
  id: E_COUPON_SEGMENT_TYPE;
  content: string;
}[] = [
  {
    id: TAB_CATEGORY,
    content: '카테고리',
  },
  { id: TAB_BRAND, content: '선물하기' },
];
